import {
  Box,
  Button, Card, CardContent, CardMedia,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
  useMediaQuery, useTheme
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { collection, getDocs, query, where } from 'firebase/firestore';
import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';

import { db } from '../../firebase';


// Create Theme Context
const ThemeContext = createContext();

const FilteredEvents = () => {
  const [events, setEvents] = useState([]);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({
      privacy: [],
      eventType: [],
      price: [],
    });
    
    useEffect(() => {
        const fetchEvents = async () => {
          try {
            const querySnapshot = await getDocs(collection(db, "events"));
            const eventList = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data(),
            }));
            setEvents(eventList);
            setFilteredEvents(eventList); // Initialize with all events
          } catch (error) {
            console.error("Error fetching events:", error);
          } finally {
            setLoading(false);
          }
        };
        
        fetchEvents();
      }, []);

      // Update filters dynamically
      useEffect(() => {
        let filtered = events.filter(event => {
          const matchesPrivacy = 
            filters.privacy.length === 0 || filters.privacy.includes(event.privacy);
          
          const matchesType = 
            filters.eventType.length === 0 || filters.eventType.includes(event.type);
          
          const matchesPrice = 
            filters.price.length === 0 || filters.price.includes(event.price);
    
          return matchesPrivacy && matchesType && matchesPrice;
        });
    
        setFilteredEvents(filtered);
      }, [filters, events]);
    
       // Handle filter changes
  const handleFilterChange = (category, value) => {
    setFilters(prevFilters => {
      const newValues = prevFilters[category].includes(value)
        ? prevFilters[category].filter(v => v !== value) // Remove if already selected
        : [...prevFilters[category], value]; // Add if not selected
      
      return { ...prevFilters, [category]: newValues };
    });
  };
    
    const { darkMode, toggleDarkMode } = useContext(ThemeContext);
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.down("lg"));
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { eventCode } = useParams();  // Capture the eventCode from the URL
    const [eventDetails, setEventDetails] = useState(null);
    const [eventDocId, setEventDocId] = useState(null);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        if (eventCode) {
          fetchEvent(eventCode);
        }
      }, [eventCode]);
   
      const fetchEvent = async (code) => {
        try {
          setError('');
          setEventDetails(null);
          setEventDocId(null);
    
          // Find the event document by eventCode
          const eventsRef = collection(db, 'events');
          const eventQuery = query(eventsRef, where('eventCode', '==', code));
          const eventSnapshot = await getDocs(eventQuery);
    
          if (!eventSnapshot.empty) {
            // Assume the first matching event document
            const eventDoc = eventSnapshot.docs[0];
            const eventData = eventDoc.data();

            // Setting the page title 
            {document.title = "nKuvu - " + eventData.eventName}
    
            setEventDocId(eventDoc.id);  // Store document ID for post retrieval
            setEventDetails({
              eventImage: eventData.eventImageURL,
              eventName: eventData.eventName,
              eventCode: eventData.eventCode,
              eventOwnerName: eventData.eventOwnerName,
            });
          } else {
            setError('No event found with that event code.');
          }
        } catch (err) {
          console.error("Error fetching event:", err);
          setError('Failed to retrieve event data.');
        }
      };

      const handleCheckboxChange = (category, value) => {
        setFilters((prev) => {
          const updatedCategory = prev[category].includes(value)
            ? prev[category].filter((v) => v !== value) // Remove if already checked
            : [...prev[category], value]; // Add if unchecked
    
          return { ...prev, [category]: updatedCategory };
        });
      };
        
    const clearFilters = () => {
      setFilters({ privacy: [], eventType: [], price: [] });
    };
      
      if (loading) {
        return (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
            <CircularProgress />
          </Box>
        );
      }
    
    
  return (
     <Container component="main" id="explore-main" 
          sx={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: { xs: 4, sm: 8 },
            py: { xs: 8, sm: 10 },
            textAlign: { sm: 'center', md: 'left' },
            paddingLeft: '0',
            paddingRight: '0',
          }}>
    
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: isMobile
              ? "1fr"
              : isMedium
              ? "30% 70%"
              : "20% 60% 20%",
            // gap: "20px",
            maxWidth: "1200px !important",
            width: "100%",            
          }}
          >
          {/* Left Sidebar */}
          <Box sx={{   minHeight: "300px" }}>          
            
          <Box
            flexGrow={1}
            padding={2}
            marginBottom={3}
            sx={{ alignItems: "center", bgcolor: 'background.paper', borderRadius:3,}}>
            {/* Privacy Filter */}
            <Grid item xs={12} sm={4}>                
                <FormGroup>
                <h3>Privacy</h3>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={filters.privacy.includes("public")}
                      onChange={() => handleCheckboxChange("privacy", "public")}
                    />
                  }
                  label="Public"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={filters.privacy.includes("private")}
                      onChange={() => handleCheckboxChange("privacy", "private")}
                    />
                  }
                  label="Private"
                />
              </FormGroup>
              </Grid>
          </Box>

          <Box
            flexGrow={1}
            padding={2}
            marginBottom={3}
            sx={{ alignItems: "center", bgcolor: 'background.paper', borderRadius:3,}}>
            {/* Event Type Filter */}
            <Grid item xs={12} sm={4}>
                <FormGroup>
                <h3>Event Type</h3>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={filters.eventType.includes("weddings")}
                      onChange={() => handleCheckboxChange("eventType", "weddings")}
                    />
                  }
                  label="Weddings"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={filters.eventType.includes("conference")}
                      onChange={() => handleCheckboxChange("eventType", "conference")}
                    />
                  }
                  label="Conference"
                />
              </FormGroup>
                
              </Grid>
          </Box>
        <Box
          flexGrow={1}
          padding={1}
          marginBottom={3}
          sx={{ alignItems: "center", bgcolor: 'background.paper', borderRadius:3,}}>          
                 
          {/* Price Filter */}
          <Grid item xs={12} sm={4}>
          <FormGroup>
            <h3>Price</h3>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.price.includes("paid")}
                  onChange={() => handleCheckboxChange("price", "paid")}
                />
              }
              label="Paid"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.price.includes("free")}
                  onChange={() => handleCheckboxChange("price", "free")}
                />
              }
              label="Free"
            />
          </FormGroup>
          </Grid>
        </Box>

        <Box
            flexGrow={1}
            padding={2}
            marginBottom={3}
            sx={{ alignItems: "center", bgcolor: 'background.paper', borderRadius:3,}}>
            {/* 🆕 "Clear Filters" Button */}
            <Button 
              variant="contained" 
              color="secondary" 
              sx={{ mt: 2 }} 
              onClick={clearFilters}
            >
              Clear Filters
            </Button>
          </Box>
        
      </Box>

          {/* Main Content */}
      <Box  paddingLeft={2}  paddingRight={2}  
        sx={{ minHeight: "400px", 
              }}>           
        {/* Event List Section */}
        <Grid container spacing={2} >
          {filteredEvents.map(event => (
            <Grid item xs={12} key={event.id} >
              <Card 
                sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, cursor: "pointer" }}
                onClick={() => navigate(`/explore/${event.eventCode}`)}
               
              >
                {/* Cover Image */}
                <CardMedia
                  component="img"
                  image={event.eventImageURL || "https://via.placeholder.com/150"} // Default image
                  alt={event.eventName}
                  sx={{ width: { xs: "100%", sm: 200 }, height: 150 }}
                />
                
                {/* Event Info */}
                <CardContent sx={{ flex: 1 }}>
                  <Typography variant="body2" fontWeight="bold">
                    {event.eventName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {event.eventDescription}
                  </Typography>
                  <Typography variant="body2" color="primary" mt={1}>
                    {/* 📅 { new Date(event.eventStartDate.seconds * 1000).toLocaleString()} | 📍 {event.eventLocation} */}
                  </Typography>
                  <Typography variant="body2" color="secondary" mt={1}>
                    {event.eventVisibility}  | {event.eventPrice} Free
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>            
      </Box>

          {/* Right Sidebar */}
      <Box 
            flexGrow={1}
            padding={1}
            marginBottom={3}
            sx={{ alignItems: "center", 
            borderRadius:3,  minHeight: "300px"}}>
                     
          <Typography variant="body2" >Featured</Typography>
      <Grid container spacing={2} >
          {filteredEvents.map(event => (
            <Grid item xs={12} key={event.id} >
              <Card sx={{ maxWidth: 345}} elevation={0} onClick={() => navigate(`/event/${event.id}`)} 
                >
                <CardMedia
                  sx={{ width: { xs: "100%", sm: "100%" }, height: 150 }}
                  image={event.eventImageURL || "https://via.placeholder.com/150"} // Default image
                  alt={event.eventName}
                  title={event.eventName}
                />
                <CardContent>
                  <Typography gutterBottom variant="body2"  component="div">
                  {event.eventName}
                  </Typography>                 
                  <Typography variant="body2" color="primary" mt={1}>
                    {/* 📅 { new Date(event.eventStartDate.seconds * 1000).toLocaleString()}  */}
                  </Typography>
                  <Typography variant="body2" color="primary" mt={1}>
                  📍 {event.eventLocation}
                  </Typography>
                  
                </CardContent>                
              </Card>
              
            </Grid>
          ))}
        </Grid>                
      </Box>
      </Box>
    </Container>  
  );
};

// Theme Provider Wrapper
const App = () => {
  const [darkMode, setDarkMode] = useState(false);

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
    },
  });

  const toggleDarkMode = () => setDarkMode(!darkMode);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <ThemeProvider theme={theme}>
        <FilteredEvents />
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default App;